import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=d941dada&"
var script = {}
import style0 from "./app-footer.vue?vue&type=style&index=0&id=d941dada&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports